import { render, staticRenderFns } from "./Procedures.vue?vue&type=template&id=7a6e68b8"
import script from "./Procedures.vue?vue&type=script&lang=js"
export * from "./Procedures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports